import { render, staticRenderFns } from "./MerchantStatementsDetail.vue?vue&type=template&id=35b2f66c&scoped=true&"
import script from "./MerchantStatementsDetail.vue?vue&type=script&lang=js&"
export * from "./MerchantStatementsDetail.vue?vue&type=script&lang=js&"
import style0 from "./MerchantStatementsDetail.vue?vue&type=style&index=0&id=35b2f66c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b2f66c",
  null
  
)

export default component.exports